import {Component, PLATFORM_ID, Inject, OnInit, ViewChild} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './services/loader.service';
import {ParametreService} from './applications/parametre/parametre.service';
import {GeneralResponse} from './applications/parametre/parametre.model';
import {AuthService} from './applications/securite/service/auth.service';
import {CandidatService} from './applications/candidat/services/candidat.service';
import {StructureService} from './applications/structure/services/structure.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    @ViewChild('content') content: any;

    // Pour la barre de progression
    loaders = this.loader.progress$.pipe(
        delay(1000),
        withLatestFrom(this.loader.progress$),
        map(v => v[1]),
    );
    isMobileOrTablet = false;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private loader: LoadingBarService,
        private translate: TranslateService,
        public loaderService: LoaderService,
        public parametreService: ParametreService,
        public authService: AuthService,
        public serviceCandidat: CandidatService,
        public structureService: StructureService,
        private modalService: NgbModal,
    private router: Router
    ) {
        // this.loaderService.hideLoader(); // Cacher le splash une fois les données chargées

        if (isPlatformBrowser(this.platformId)) {
            translate.setDefaultLang('en');
            translate.addLangs(['en', 'de', 'es', 'fr', 'pt', 'cn', 'ae']);
        }
    }

    ngOnInit() {

        this.isMobileOrTablet = this.authService.isMobile() || this.authService.isTablet();
        this.parametreService.initCommonParams().subscribe(() => {
            if(this.isMobileOrTablet){
                this.openModalPhoneControle();
            }
            const token = this.authService.getToken();
            console.log("Token récupéré:", token);

            if (!token) {
                this.loaderService.hideLoader(); // Cacher le splash si aucun token
                return;
            }

            this.authService.loginUserByToken(token).subscribe(
                (data) => {
                    const responseGeneral = data as GeneralResponse;
                    console.log("Réponse de l'API:", responseGeneral);
                    if (responseGeneral.success) {
                        console.log("user data by token: ", responseGeneral.data["user"]);
                        this.authService.loggedUser = responseGeneral.data["user"];

                        if (!this.authService.loggedUser || this.authService.loggedUser.email_verified_at === null) {
                            // Profil non vérifié, cacher le splash et ne pas continuer
                            this.loaderService.hideLoader();
                            return;
                        }
                        if(this.authService.loggedUser.role_id==1){
                            this.serviceCandidat.getCandidatForInfoByUser(this.authService.loggedUser.id, this.authService.loggedUser.role_id, 'GUIDE');

                        }
                        if(this.authService.loggedUser.role_id==2){
                            this.structureService.getStructureForInfoByUser(this.authService.loggedUser.id,'GUIDE');
                        }

                        this.authService.getUserDataFile(this.authService.loggedUser);
                        console.log("custom user data par token: ", this.authService.loggedUser);
                        // Tout est bon, cacher le splash
                        this.loaderService.hideLoader();
                    } else {
                        // Erreur d'authentification
                        this.loaderService.hideLoader();
                    }
                },
                (error) => {
                    console.error('Erreur d\'authentification:', error);
                    // Gérer l'erreur d'authentification
                    this.loaderService.hideLoader();
                }
            );
        });

        // if(!this.isMobileOrTablet){
        //     this.parametreService.initCommonParams().subscribe(() => {
        //         this.openModalPhoneControle();
        //         const token = this.authService.getToken();
        //         console.log("Token récupéré:", token);
        //
        //         if (!token) {
        //             this.loaderService.hideLoader(); // Cacher le splash si aucun token
        //             return;
        //         }
        //
        //         this.authService.loginUserByToken(token).subscribe(
        //             (data) => {
        //                 const responseGeneral = data as GeneralResponse;
        //                 console.log("Réponse de l'API:", responseGeneral);
        //                 if (responseGeneral.success) {
        //                     console.log("user data by token: ", responseGeneral.data["user"]);
        //                     this.authService.loggedUser = responseGeneral.data["user"];
        //
        //                     if (!this.authService.loggedUser || this.authService.loggedUser.email_verified_at === null) {
        //                         // Profil non vérifié, cacher le splash et ne pas continuer
        //                         this.loaderService.hideLoader();
        //                         return;
        //                     }
        //                     if(this.authService.loggedUser.role_id==1){
        //                         this.serviceCandidat.getCandidatForInfoByUser(this.authService.loggedUser.id, this.authService.loggedUser.role_id, 'GUIDE');
        //
        //                     }
        //                     if(this.authService.loggedUser.role_id==2){
        //                         this.structureService.getStructureForInfoByUser(this.authService.loggedUser.id,'GUIDE');
        //                     }
        //
        //                     this.authService.getUserDataFile(this.authService.loggedUser);
        //                     console.log("custom user data par token: ", this.authService.loggedUser);
        //                     // Tout est bon, cacher le splash
        //                     this.loaderService.hideLoader();
        //                 } else {
        //                     // Erreur d'authentification
        //                     this.loaderService.hideLoader();
        //                 }
        //             },
        //             (error) => {
        //                 console.error('Erreur d\'authentification:', error);
        //                 // Gérer l'erreur d'authentification
        //                 this.loaderService.hideLoader();
        //             }
        //         );
        //     });
        //
        // }else{
        //     this.loaderService.hideLoader(); //
        //         // Redirection vers la page d'avertissement
        //         this.router.navigate(['/mobile-warning']);
        //         return false;
        //
        // }

}
    openModalPhoneControle() {
        this.modalService.open(this.content, {
            centered: true,
            size: 'lg',
            backdrop: true,
            // backdrop: 'static' // Empêche la fermeture en cliquant en dehors
        });
    }

    protected readonly faTimes = faTimes;
}
